// extracted by mini-css-extract-plugin
module.exports = {"link":"navigations_link__1pvqB"};